import { LuShoppingCart } from "react-icons/lu";
import { IoChatbubbleOutline } from "react-icons/io5";
import { IoNotificationsOutline } from "react-icons/io5";
import { RxHamburgerMenu } from "react-icons/rx";
import UserProfileAvatar from "./UserProfileAvater";
import NavDrawer from "./NavDrawer";
import { FaUser } from "react-icons/fa";
import { MdWavingHand } from "react-icons/md";
import NotificationIcon from "./NotificationIcon";

export default function UDHeader() {
	const content = (
		<header className=" min-h-[3rem] z-20 bg-[#034052] mb-[2rem]  w-[95%]  lg:mx-0  lg:ml-auto     lg:w-[80%]  mx-auto  text-[1.2rem]       sticky  top-0">
			{" "}
			<section className=" h-[4.5rem]  border-b-2   border-b-gray-200   lg:px-[1rem]  bg-white  min-w-full   lg:rounded-tl-[2rem]  flex    justify-between   items-center  ">
				{/*NAV BTN  */}
				<div className="    lg:hidden   border-2  border-gray-200  rounded-lg ">
					<NavDrawer />
				</div>
				{/* HEADER  */}
				<div className="hidden   lg:flex  justify-center items-center gap-[0.5rem] ">
					<div className="  w-[2.5rem]  h-[2.5rem] grid place-content-center  rounded-full  bg-[#E5CCF5]">
						<FaUser className="" />
					</div>
					<div>
						<h5>Anthony Williams</h5>
						<p className="text-gray-500  text-[0.9rem]  tracking-wide   ">
							Welcome back.{" "}
							<MdWavingHand className="inline-block text-[#E4914E]" />
						</p>
					</div>
				</div>

				<div className="flex   justify-center items-center  gap-[1.5rem]">
					<LuShoppingCart />
					<IoChatbubbleOutline />
					<NotificationIcon count={0} />
					<UserProfileAvatar />
				</div>
			</section>
		</header>
	);

	return content;
}
